import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "mb-4 mt-1" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Assets ")
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = { class: "bg-gray-700 p-2 rounded-lg mr-4 relative" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "text-md font-medium" }
const _hoisted_9 = { class: "text-sm text-gray-200 font-medium" }
const _hoisted_10 = { class: "text-md font-medium text-right" }
const _hoisted_11 = { class: "text-sm text-gray-200 font-medium text-right" }
const _hoisted_12 = {
  key: 0,
  class: "text-center mt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_ECharts = _resolveComponent("ECharts")!
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
        key: 0,
        style: { height: '632px' }
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BalCard, { style: { minHeight: '632px' } }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "info",
                    size: "sm",
                    class: "ml-1 text-gray-400 -mb-px"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$t('portfolioAssetsPieChartInfo'),
                    class: "w-52"
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ECharts, {
              ref: "chartInstance",
              class: "h-64 w-full",
              option: _ctx.chartConfig,
              autoresize: "",
              "update-options": { replaceMerge: 'series' }
            }, null, 8, ["option"]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets.slice(0, _ctx.showAll ? _ctx.assets.length : 4), (asset, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex items-center mb-2",
                  key: asset.address
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_BalAsset, {
                      address: asset.address,
                      size: 32
                    }, null, 8, ["address"]),
                    (asset.percentOfPortfolio >= 0.03)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-full h-3 w-3 bg-gold-500 absolute -top-1 -left-1",
                          style: _normalizeStyle({ backgroundColor: _ctx.chartColors2[i] })
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(asset.symbol), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.fNum(asset.percentOfPortfolio, 'percent')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.fNum(asset.balance, 'token')) + " ", 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fNum(asset.totalValue, 'usd')), 1)
                  ])
                ]))
              }), 128)),
              (_ctx.assets.length > 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShowAll())),
                      class: "text-white font-medium show-btn"
                    }, _toDisplayString(_ctx.showAll ? 'Hide' : `Show all (${_ctx.assets.length})`), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]))
}